import React, { useEffect } from 'react'
import styled from '@emotion/styled'

import { fontSizeXSmall, fontSize2XSmall, fontSize3XSmall, fontWeightBold, fontWeightRegular } from '../../constants/principles'
import { BrowserUtils, QuestionUtils, StringUtils, ArrayUtils } from '../../utils/siteUtils'
import * as Icons from '../compiledSVG/icon'
import Icon from '../generic/toggles/radioIconToggle'

export default ({ anyAnswered, svgIcons, saveQuestionResponse, setShowModal, conditionQuestions = [], titleOverride, subtitleOverride, disclaimerOverride, getQuestionResponse, setBadgeCnt, isVisible = true }) => {
  const isDesktop = BrowserUtils.isDesktop()
  const representativeQuestion = conditionQuestions.filter(question => question.item.toLowerCase().startsWith(svgIcons[0].toLowerCase()))[0]
  const title = titleOverride || (representativeQuestion && representativeQuestion.subsection)
  const subtitle = subtitleOverride || (representativeQuestion && representativeQuestion.subsectionDescription.split('\\n')[0])
  const disclaimer = disclaimerOverride || (representativeQuestion && representativeQuestion.subsectionDescription.split('\\n')[1])
  const dividedArray = isDesktop ? ArrayUtils.divideArray(svgIcons, ArrayUtils.findLen(svgIcons.length)) : [svgIcons]

  var cnt = 0

  function onClickFunc(qId, val, condQ, repQ, divArr) {
    qId !== '' && saveQuestionResponse(qId, val)

    const qResp = qId !== '' && getQuestionResponse(qId)
    if (repQ && repQ.subsectionCode.toLowerCase() === 'warninglights') {
      cnt = divArr
        .map(subArr => {
          const sub = subArr
            .map(icon => ({
              [icon]: anyAnswered(QuestionUtils.getAssociatedQuestions(condQ, icon, repQ && repQ.subsectionCode))
            }))
            .reduce((acc, ndx) => {
              if (Object.values(ndx)[0]) acc++
              return acc
            }, 0)
          return sub
        })
        .reduce((acc, curr) => acc + curr)

      if (qId !== '') qResp && qResp.v === 0 ? cnt-- : cnt++
    }
    setBadgeCnt(items => ({ ...items, dashboard: cnt }))
  }

  useEffect(() => {
    setBadgeCnt && onClickFunc('', 0, conditionQuestions, representativeQuestion, dividedArray)
  }, [setBadgeCnt])

  return (
    isVisible && (
      <>
        <StyledH1 isDesktop={isDesktop}>{title}</StyledH1>
        <StyledH2> {subtitle}</StyledH2>
        <StyledH3>{disclaimer}</StyledH3>
        <IconDiv>
          {dividedArray.map((subArray, i) => (
            <SubDiv key={i}>
              {subArray.map((icon, index) => {
                const questions = QuestionUtils.getAssociatedQuestions(conditionQuestions, icon, representativeQuestion && representativeQuestion.subsectionCode)
                const iconSvg = Object.keys(Icons).find(Icon => StringUtils.cleanString(icon).includes(Icon))

                return (
                  questions.length > 0 && (
                    <Icon
                      key={index}
                      textArray={[icon]}
                      id={icon}
                      onClickItem={() =>
                        questions.length === 1 && questions[0].questionType === 'ToggleSelect'
                          ? onClickFunc(questions[0].questionId, 0, conditionQuestions, representativeQuestion, dividedArray)
                          : setShowModal({ name: icon, subsectionCode: representativeQuestion.subsectionCode })
                      }
                      selectedIndex={anyAnswered(questions) && 0}
                      Svgs={[Icons[iconSvg]]}
                    />
                  )
                )
              })}
            </SubDiv>
          ))}
        </IconDiv>
      </>
    )
  )
}

const SubDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`
const IconDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`
const StyledH1 = styled.h1`
  font-size: ${fontSizeXSmall};
  font-weight: ${fontWeightBold};
  margin: 0 0 8px 0;
`
const StyledH3 = styled.h3`
  font-size: ${fontSize3XSmall};
  font-weight: ${fontWeightRegular};
  margin: 8px 0;
`
const StyledH2 = styled.h2`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightRegular};
  margin: 8px 0;
`
